import type { SVGProps } from 'react'
const SvgSyOrder = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={14} height={18} x={5} y={3} fillOpacity={0.24} rx={2} />
		<path d="M9.5 7a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
		<rect width={1} height={1} x={7} y={7} rx={0.5} />
		<rect width={1} height={1} x={7} y={10} rx={0.5} />
		<rect width={1} height={1} x={7} y={13} rx={0.5} />
		<rect width={1} height={1} x={7} y={16} rx={0.5} />
	</svg>
)
export default SvgSyOrder
